const {
  id,
  apiRootUri,
  landingPage,
  gaTrackerName,
  currentLanguage,
  tenantKeyDataOverride
} = window.locatorTenancy;

let analyticsSessionId = '';

try {
  analyticsSessionId = window.GainNode.getAll()[0].get('clientId');
}
catch {
  analyticsSessionId = `session${Math.random() * 10000}`;
}


// Constants related to global settings for a tenant.
const GLOBAL = {
  CURRENT_TENANT: tenantKeyDataOverride ? tenantKeyDataOverride : id,
  GA_TRACKER_NAME: gaTrackerName,
  GEO_WRAP_DEV: '3TEII8EI+Q28a17/rlNiVM74FTSylfrYuxNHEtKZhyC03aeTaWAKsP+rONcTPfGU',
  GEO_WRAP_QA: 'Ht2CCenilYyGfCAXCpifB1ZlwNHPRUpKnHDiB9hY+uG/tISS1IuZR50zLL/Y4/8z',
  GEO_WRAP_STAGE: 'yhxHsDQICsy6GfHJfR04t/WKAizwYsS0ZE+beDDTNbZZmuBuRY+v9pkHkvsJf2/I',
  GEO_WRAP_PROD: 'Kv2FdLSIkkVgN6F74P9pyFkJnAA7Q9AgyxiNlwE2+RfZMigyqN4aA0U4PyWtixkM',
  API_URL: apiRootUri ?? process.env.LOCATOR_API,
  ANALYTICS_SESSION_ID: analyticsSessionId,
  CURRENT_LANGUAGE: currentLanguage || 'en-us',
  CURRENT_LANDING_PAGE: landingPage ? landingPage : '',
  EXPERT_TEXT_MAP: {
    E_EXPERT: 'Essilor Expert',
    V_EXPERT: 'Essilor Partner',
    V_SPEZIAL: 'Varilux Spezialist',
    E_PPART: 'Essilor Platinum Partners',
    E_REACH: 'Essilor Reach',
    T_CERT: 'Transitions Certified',
    E_PARTNER: 'Essilor Partner',
    C_PARTNER: 'Chain Partner',
    O_N_PRO: 'Opticien Nikon Pro',
    AUTHORIZED_RETAILER: 'Authorized Retailer',
    N_L_P: 'Nikon Lenswear Partner',
    'Alliance Professionnel Reconnu': 'Alliance Professionnel Reconnu',
    'Alliance Recognized Professional': 'Alliance Recognized Professional',
    'Nikon旗艦概念店': 'Nikon旗艦概念店',
    'Nikon鏡片視光體驗中心': 'Nikon鏡片視光體驗中心',
    STELLEST_FOR_CHILDREN: 'Stellest - Myopia control lenses for children',
    MIOPIA_INFANTIL: 'Comprometidos con la miopía infantil',
    MYOPIA: 'Certified Myopia Experts'
  }
};

export default { GLOBAL };
